import AdsError from './AdsError.js'

export class GetInstantOfferAdsError extends AdsError {}
